<!--==============================
=            PARALLAX            =
===============================-->
<template>
  <div>
    <v-row>
      <base-header>
        <div slot="page-header">Parallax</div>
      </base-header>
    </v-row>
         <v-row>
        <v-col class="col-12 col-md-6 col-sm-12">
          <base-card>
            <div slot="card-header">Usage
            </div>
            <div slot="card-subheader">A parallax causes a shift in a background image when the user scrolls the page.
            </div>
            <div slot="card-body">

              <v-parallax src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"></v-parallax>
            </div>
          </base-card>

        </v-col>
        <v-col class="col-12 col-md-6 col-sm-12">
          <base-card>
            <div slot="card-header">
              #Content

            </div>
            <div slot="card-subheader">You can also place any content inside of the parallax. This allows you to use the
              parallax as a hero image.</div>
            <div slot="card-body">

              <v-parallax dark src="https://cdn.vuetifyjs.com/images/backgrounds/vbanner.jpg">
                <v-row align="center" justify="center">
                  <v-col class="text-center" cols="12">
                    <h1 class="text-h4 font-weight-thin mb-4">
                      Vuetify
                    </h1>
                    <h4 class="subheading">
                      Build your application today!
                    </h4>
                  </v-col>
                </v-row>
              </v-parallax>
            </div>
          </base-card>

        </v-col>
        <v-col class="col-12 col-md-12 col-sm-12">
          <base-card>
            <div slot="card-header">

              Custom height
            </div>
            <div slot="card-subheader">You can specify a custom height on a parallax. Keep in mind this can break the
              parallax if your image is not sized properly

            </div>
            <div slot="card-body">

              <v-parallax height="200" src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"></v-parallax>
            </div>
          </base-card>

        </v-col>
      </v-row>
  </div>

</template>
<script>
  import BaseCard from "../../components/Base/BaseCard.vue";
  import BaseHeader from '../../components/Base/BaseHeader'
  export default {
    components: {
      BaseCard,
      BaseHeader
    },
    
  }
</script>
<!--====  End of PARALLAX  ====-->
